import React from 'react';

export default function Image(props) {
  return (
    <picture className={props.className} style={props.style}>
      <source
        className={props.imgClass}
        srcSet={props.webp}
        type="image/webp"
        alt={props.alt}
      />
      <source
        className={props.imgClass}
        srcSet={props.fallback}
        alt={props.alt}
      />
      <img className={props.imgClass} src={props.fallback} alt={props.alt} />
    </picture>
  );
}
